const options = { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" };
const webAppUrl = "https://ensuring-supply.olympe.io/";
const riskAndCrisisDashboardUrl = "https://app.powerbi.com/groups/me/apps/7bf41880-7ece-4733-9181-6b6c720ddb08/reports/6c22dc90-b92d-4511-ae2a-32b2b5673927/ReportSection?ctid=12a3af23-a769-4654-847f-958f3d479f4a&experience=power-bi";

export const generateEmailContents = (userData) => {
  let emailContent = `
    <p>Hi ${userData.userName},</p>
    <p>Please refer to the below events that could potentially impact supply:</p>
    <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">
      <thead>
        <tr>
          <th>Event Types</th>
          <th>Event Severity level</th>
          <th>Event date</th> 
          <th>Event title</th>
        </tr>
      </thead>
      <tbody>`;

  const events = userData.eventDetails;

  //added optional chaining to prevent null pointer errors
  events?.forEach(event => {
    // Find the recent event that matches the event_id

    let color = event.event_bulletins_severity === "Severe"
      ? "#880808"
      : event.event_bulletins_severity === "High"
        ? "red"
        : "yellow";


    emailContent += `
                <tr>
                  <td style="text-align: center;" >${event.potentail_crisis_trigger || "Unknown"}</td>
                  <td style="color:${color}; text-align: center;">${event.event_bulletins_severity}</td>
                  <td style="text-align: center;" >${new Date(event.event_last_modified_date).toLocaleDateString("en-US", options) || "NA"}</td> 
                  <td style="text-align: center;" >${event.title || "No Title"}</td>
                </tr>`;

  });


  emailContent += `
      </tbody>
    </table>
    <p>To review the full detail of an event & vendor sites that could be impacted, please click on this
    <a href="${webAppUrl}">link</a> to go to the Risk & Crisis WebApp, login to the webapp, select "Risk & Crisis" title & check the potential
    crisis trigger section.</p>
    <p>Please check with your vendors whether the events are impacting their capacity to supply & provide your inputs accordingly in the <a href="${webAppUrl}">Risk & Crisis WebApp</a>.</p>
    <p>As an option, you could also review the full details of an event & vendor sites that could be impacted via the <a href="${riskAndCrisisDashboardUrl}">Risk & Crisis Dashboard</a> in the potential crisis view.</p>
    <p>Please do not reply to this email as this is an automatically generated notification.</p>

    <p>Thank you for your collaboration.</p>
    <p>Your Ensuring Supply team</p>`;

  return emailContent;
};